import { encode } from 'querystring-es3'
const axios = require('axios')

export default {
  methods: {
    getAllPflanzenschutzmittelTypes (query) {
      query = encode({ query: window.btoa(JSON.stringify(query)) })
      return axios.post(axios.defaults.baseURL + 'api/Pflanzenschutzmitteltyp/getAllPflanzenschutzmittelTypes/pwaCallGetAllPflanzenschutzmittelTypes', query)
    }
  }
}
